import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
import mutations from './mutations';

import api from './modules/api';
import auth from './modules/auth';
import bud from './modules/bud';
import school from './modules/school';
import system from './modules/system';

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    fullscreen: false,
    showDrawer: true,
    apiRoot: "/api/v2",
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    paths: ['api.filters','api.deviceCount.data','auth.claims.sitecodes','school.selected']
  })],
  actions,
  mutations,
  modules: {
    api,
    auth,
    bud,
    school,
    system,
  }
});

export default store;
